export class Product {
    public id: number;
    public barcode: string;
    public name: string;
    public weight: number;
    public type: number;
    public namedType: string;

    constructor(id: number, barcode: string, name: string, weight: number, type: number, namedType?: string) {
        this.id = id;
        this.barcode = barcode;
        this.name = name;
        this.weight = weight;
        this.type = type;
        this.namedType = (this.type === 0) ? "BOTTLE" : "CAN"
    }
}